// B1.4: instructions domain methods (move-only from client.ts).
import { ApiClientCore, buildQueryString } from './http/core';

export class InstructionsApi extends ApiClientCore {
  // ─── Instructions ───────────────────────────────────────────────────────────
  async getInstructions(params: Record<string, any> = {}): Promise<any> {
    return this.get(`/api/v1/instructions${buildQueryString(params)}`);
  }
  async getInstruction(id: number): Promise<any> {
    return this.get(`/api/v1/instructions/${id}`);
  }
  async getInstructionStats(): Promise<any> {
    return this.get('/api/v1/instructions/stats');
  }
  async getInstructionCategories(): Promise<any> {
    return this.get('/api/v1/instructions/categories');
  }
  async getInstructionCategoriesList(params: Record<string, any> = {}): Promise<any> {
    return this.get(`/api/v1/instruction-categories${buildQueryString(params)}`);
  }
  async createInstruction(data: any): Promise<any> {
    return this.post('/api/v1/instructions', data);
  }
  async updateInstruction(id: number, data: any): Promise<any> {
    return this.put(`/api/v1/instructions/${id}`, data);
  }
  async createInstructionCategory(data: any): Promise<any> {
    return this.post('/api/v1/instruction-categories', data);
  }
  async deleteInstruction(id: number): Promise<any> {
    return this.delete(`/api/v1/instructions/${id}`);
  }
  async deleteInstructionCategory(id: number, params: Record<string, any> = {}): Promise<any> {
    return this.delete(`/api/v1/instruction-categories/${id}${buildQueryString(params)}`);
  }
  async updateInstructionCategory(id: number, data: any): Promise<any> {
    return this.put(`/api/v1/instruction-categories/${id}`, data);
  }
  async getInstructionVersions(instructionId: number): Promise<any> {
    return this.get(`/api/v1/instructions/${instructionId}/versions`);
  }
  async restoreInstructionVersion(instructionId: number, versionNumber: number, notes?: string): Promise<any> {
    return this.post(
      `/api/v1/instructions/${instructionId}/restore/${versionNumber}${buildQueryString({ restore_notes: notes })}`
    );
  }
  async compareInstructionVersions(instructionId: number, v1?: number, v2?: number): Promise<any> {
    return this.get(
      `/api/v1/instructions/${instructionId}/compare${buildQueryString({ version_a: v1, version_b: v2 })}`
    );
  }
  async getInstructionReadStats(instructionId: number): Promise<any> {
    return this.get(`/api/v1/instructions/${instructionId}/stats`);
  }
  async getInstructionUnreadEmployees(instructionId: number, limit = 100): Promise<any> {
    return this.get(`/api/v1/instructions/${instructionId}/unread-employees${buildQueryString({ limit })}`);
  }
}
